import React from 'react';
interface LogoProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}
const sizeMap = {
  sm: 'h-14 md:h-20',
  md: 'h-24',
  lg: 'h-28 md:h-32'
};
export function Logo({
  size = 'md',
  className = ''
}: LogoProps) {
  return <img src="https://cdn.magicpatterns.com/uploads/3LsFraVfZ6SGDyzpZYZmJe/RIAM_LOGO.png" alt="Riam Beauty Studio" className={`${sizeMap[size]} w-auto object-contain select-none pointer-events-none ${className}`} style={{
    mixBlendMode: 'screen',
    WebkitMaskImage: 'radial-gradient(ellipse 60% 60% at center, black 40%, rgba(0,0,0,0.85) 55%, rgba(0,0,0,0.4) 75%, transparent 95%)',
    maskImage: 'radial-gradient(ellipse 60% 60% at center, black 40%, rgba(0,0,0,0.85) 55%, rgba(0,0,0,0.4) 75%, transparent 95%)',
    filter: 'brightness(1.15) contrast(1.1)'
  }} draggable={false} data-id="element-360" />;
}